import verifyPayload from "../utils/payloadVerification.js";
import { config } from "../utils/setup.js";
import { logs } from "../utils/logShooter.js";
import chalk from "chalk";
import { checkMoengage } from "../utils/connectors/moengage.js";
/**
 * Handles event tracking to MoEngage
 * 
 * @param {Object} eventPayload - The event payload object
 * @param {string} eventPayload.message - Event message
 * @param {string} [eventPayload.origin] - Origin of the event
 * @param {string} [eventPayload.version] - Version information
 * @param {string} [eventPayload.deviceType] - Type of device
 * @param {('INFO'|'WARN'|'ERROR'|'DEBUG')} eventPayload.severityLevel - Severity level of the event
 * @param {string} [eventPayload.path] - Path information
 * @param {string} [eventPayload.sourceIPAddress] - Source IP address
 * @param {string} [eventPayload.userId] - User ID
 * @throws {Error} If the event payload validation fails
 */
function event_track(eventPayload) {
    eventPayload.severityLevel = "INFO";
    eventPayload = { ...eventPayload, config }
    const {error, payload} = verifyPayload(eventPayload);
    if (error) {
        throw new Error(error);
    }

    if (config.console) {
        if (typeof window === 'undefined') {
            console.log(chalk.yellow("LOGGER: ", payload.message));
        } else {
            console.log("LOGGER: ", payload.message);
        }
    }

    if (config.autoOpenSearch) {
        logs.push(payload)
    }

    const moengage = checkMoengage();
    if (moengage) {
      moengage.track_event(payload.message, payload);
    }
}

export default event_track;